import { CoLenderFinancierReducerDispatch, CoLenderFinancierReduxState, CoLenderFinancierReduxTypes, CreateCoLenderFinancierReduxState } from "./types";

const CO_LENDER_LIST_INIT_STATE = {
    data: {
        metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
                self: null,
                first: null,
                previous: null,
                next: null,
                last: null
            }
        },
        records: []
    },
    loading: false,
    error: null
};

const CoLenderFinancierListReducer = (state: CoLenderFinancierReduxState = CO_LENDER_LIST_INIT_STATE, action: CoLenderFinancierReducerDispatch) => {
    switch (action.type) {
        case CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIERS:
            return {
                ...state,
                loading: true,
                error: null
            };
        case CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIERS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload?.data,
            };
        case CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIERS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload?.error
            };
        case CoLenderFinancierReduxTypes.RESET_CO_LENDER_FINANCIER:
            return {
                ...state,
                loading: false,
                data: {},
                error: null
            };
        default:
            return { ...state };
    }
}

const CREATE_CO_LENDER_FINANCIER_INIT_STATE = {
    data: {},
    loading: false,
    error: null
};

const CreateCoLenderFinancierReducer = (state: CreateCoLenderFinancierReduxState = CREATE_CO_LENDER_FINANCIER_INIT_STATE, action: CoLenderFinancierReducerDispatch) => {
    switch (action.type) {
        case CoLenderFinancierReduxTypes.CREATE_CO_LENDER_FINANCIER:
            return {
                ...state,
                loading: true,
                error: null
            };
        case CoLenderFinancierReduxTypes.CREATE_CO_LENDER_FINANCIER_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload?.data,
            };
        case CoLenderFinancierReduxTypes.CREATE_CO_LENDER_FINANCIER_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload?.error
            };
        case CoLenderFinancierReduxTypes.RESET_CO_LENDER_FINANCIER:
            return {
                ...state,
                loading: false,
                data: {},
                error: null
            };
        default:
            return { ...state };
    }
}
const UpdateCoLenderFinancierReducer = (state: CreateCoLenderFinancierReduxState = CREATE_CO_LENDER_FINANCIER_INIT_STATE, action: CoLenderFinancierReducerDispatch) => {
    switch (action.type) {
        case CoLenderFinancierReduxTypes.UPDATE_CO_LENDER_FINANCIER:
            return {
                ...state,
                loading: true,
                error: null
            };
        case CoLenderFinancierReduxTypes.UPDATE_CO_LENDER_FINANCIER_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload?.data,
            };
        case CoLenderFinancierReduxTypes.UPDATE_CO_LENDER_FINANCIER_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload?.error
            };
        case CoLenderFinancierReduxTypes.RESET_CO_LENDER_FINANCIER:
            return {
                ...state,
                loading: false,
                data: {},
                error: null
            };
        default:
            return { ...state };
    }
}
const CoLenderFinancierReducer = (state: CreateCoLenderFinancierReduxState = CREATE_CO_LENDER_FINANCIER_INIT_STATE, action: CoLenderFinancierReducerDispatch) => {
    switch (action.type) {
        case CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_BY_ID:
            return {
                ...state,
                loading: true,
                error: null
            };
        case CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload?.data,
            };
        case CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_BY_ID_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload?.error
            };
        case CoLenderFinancierReduxTypes.RESET_CO_LENDER_FINANCIER:
            return {
                ...state,
                loading: false,
                data: {},
                error: null
            };
        default:
            return { ...state };
    }
}
const DeleteCoLenderFinancierReducer = (state: CreateCoLenderFinancierReduxState = CREATE_CO_LENDER_FINANCIER_INIT_STATE, action: CoLenderFinancierReducerDispatch) => {
    switch (action.type) {
        case CoLenderFinancierReduxTypes.DELETE_CO_LENDER_FINANCIER:
            return {
                ...state,
                loading: true,
                error: null
            };
        case CoLenderFinancierReduxTypes.DELETE_CO_LENDER_FINANCIER_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload?.data,
            };
        case CoLenderFinancierReduxTypes.DELETE_CO_LENDER_FINANCIER_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload?.error
            };
        case CoLenderFinancierReduxTypes.RESET_CO_LENDER_FINANCIER:
            return {
                ...state,
                loading: false,
                data: {},
                error: null
            };
        default:
            return { ...state };
    }
}
const CoLenderFinancierVersionsReducer = (state: CreateCoLenderFinancierReduxState = CREATE_CO_LENDER_FINANCIER_INIT_STATE, action: CoLenderFinancierReducerDispatch) => {
    switch (action.type) {
        case CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_VERSIONS:
            return {
                ...state,
                loading: true,
                data: action.payload?.data
            };
        case CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_VERSIONS_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload?.data,
            };
        }
        case CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_VERSIONS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload?.error
            };
        case CoLenderFinancierReduxTypes.RESET_CO_LENDER_FINANCIER:
            return {
                ...state,
                loading: false,
                data: {},
                error: false
            };
        default:
            return { ...state };
    }
}
const CoLenderFinancierVersionDetailsReducer = (state: CreateCoLenderFinancierReduxState = CREATE_CO_LENDER_FINANCIER_INIT_STATE, action: CoLenderFinancierReducerDispatch) => {
    switch (action.type) {
        case CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_VERSIONS_DETAILS: {
            return {
                ...state,
                loading: true,
                data: action.payload?.data,
            }
        }
        case CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_VERSIONS_DETAILS_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload?.data
            }
        }
        case CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_VERSIONS_DETAILS_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload?.error
            }
        }
        case CoLenderFinancierReduxTypes.RESET_CO_LENDER_FINANCIER: {
            return {
                ...state,
                data: {},
                loading: false,
                error: false
            }
        }
        default:
            return { ...state };
    }
}
const CoLenderFinancierLatestVersionReducer = (state: CreateCoLenderFinancierReduxState = CREATE_CO_LENDER_FINANCIER_INIT_STATE, action: CoLenderFinancierReducerDispatch) => {
    switch (action.type) {
        case CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_LATEST_VERSIONS: {
            return {
                ...state,
                loading: true
            }
        }
        case CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_LATEST_VERSIONS_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload?.data
            }
        }
        case CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_LATEST_VERSIONS_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload?.error
            }
        }
        case CoLenderFinancierReduxTypes.RESET_CO_LENDER_FINANCIER: {
            return {
                ...state,
                data: {},
                loading: false,
                error: false
            }
        }
        default:
            return { ...state };
    }
}
const ApproveCoLenderFinancierReducer = (state: CreateCoLenderFinancierReduxState = CREATE_CO_LENDER_FINANCIER_INIT_STATE, action: CoLenderFinancierReducerDispatch) => {
    switch (action.type) {
        case CoLenderFinancierReduxTypes.APPROVE_CO_LENDER_FINANCIER: {
            return {
                ...state,
                loading: true,
                data: action.payload?.data,
            }
        }
        case CoLenderFinancierReduxTypes.APPROVE_CO_LENDER_FINANCIER_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload?.data
            }
        }
        case CoLenderFinancierReduxTypes.APPROVE_CO_LENDER_FINANCIER_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload?.error
            }
        }
        case CoLenderFinancierReduxTypes.RESET_CO_LENDER_FINANCIER:
            return {
                ...state,
                loading: false,
                data: {},
                error: null
            }
        default:
            return { ...state };
    }
}
const RejectCoLenderFinancierReducer = (state: CreateCoLenderFinancierReduxState = CREATE_CO_LENDER_FINANCIER_INIT_STATE, action: CoLenderFinancierReducerDispatch) => {
    switch (action.type) {
        case CoLenderFinancierReduxTypes.REJECT_CO_LENDER_FINANCIER: {
            return {
                ...state,
                loading: true,
                data: action.payload?.data,
            }
        }
        case CoLenderFinancierReduxTypes.REJECT_CO_LENDER_FINANCIER_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload?.data
            }
        }
        case CoLenderFinancierReduxTypes.REJECT_CO_LENDER_FINANCIER_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload?.error
            }
        }
        case CoLenderFinancierReduxTypes.RESET_CO_LENDER_FINANCIER:
            return {
                ...state,
                loading: false,
                data: {},
                error: null
            }
        default:
            return { ...state };
    }
}
const BlockCoLenderFinancierReducer = (state: CreateCoLenderFinancierReduxState = CREATE_CO_LENDER_FINANCIER_INIT_STATE, action: CoLenderFinancierReducerDispatch) => {
    switch (action.type) {
        case CoLenderFinancierReduxTypes.BLOCK_CO_LENDER_FINANCIER: {
            return {
                ...state,
                loading: true,
                data: action.payload?.data,
            }
        }
        case CoLenderFinancierReduxTypes.BLOCK_CO_LENDER_FINANCIER_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload?.data
            }
        }
        case CoLenderFinancierReduxTypes.BLOCK_CO_LENDER_FINANCIER_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload?.error
            }
        }
        case CoLenderFinancierReduxTypes.RESET_CO_LENDER_FINANCIER:
            return {
                ...state,
                loading: false,
                data: {},
                error: null
            }
        default:
            return { ...state };
    }
}
const FreezeCoLenderFinancierReducer = (state: CreateCoLenderFinancierReduxState = CREATE_CO_LENDER_FINANCIER_INIT_STATE, action: CoLenderFinancierReducerDispatch) => {
    switch (action.type) {
        case CoLenderFinancierReduxTypes.FREEZE_CO_LENDER_FINANCIER: {
            return {
                ...state,
                loading: true,
                data: action.payload?.data,
            }
        }
        case CoLenderFinancierReduxTypes.FREEZE_CO_LENDER_FINANCIER_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload?.data
            }
        }
        case CoLenderFinancierReduxTypes.FREEZE_CO_LENDER_FINANCIER_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload?.error
            }
        }
        case CoLenderFinancierReduxTypes.RESET_CO_LENDER_FINANCIER:
            return {
                ...state,
                loading: false,
                data: {},
                error: null
            }
        default:
            return { ...state };
    }
}
const UnfreezeCoLenderFinancierReducer = (state: CreateCoLenderFinancierReduxState = CREATE_CO_LENDER_FINANCIER_INIT_STATE, action: CoLenderFinancierReducerDispatch) => {
    switch (action.type) {
        case CoLenderFinancierReduxTypes.UNFREEZE_CO_LENDER_FINANCIER: {
            return {
                ...state,
                loading: true,
                data: action.payload?.data,
            }
        }
        case CoLenderFinancierReduxTypes.UNFREEZE_CO_LENDER_FINANCIER_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload?.data
            }
        }
        case CoLenderFinancierReduxTypes.UNFREEZE_CO_LENDER_FINANCIER_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload?.error
            }
        }
        case CoLenderFinancierReduxTypes.RESET_CO_LENDER_FINANCIER:
            return {
                ...state,
                loading: false,
                data: {},
                error: null
            }
        default:
            return { ...state };
    }
}

export {
    CoLenderFinancierListReducer,
    CreateCoLenderFinancierReducer,
    UpdateCoLenderFinancierReducer,
    CoLenderFinancierReducer,
    DeleteCoLenderFinancierReducer,
    CoLenderFinancierVersionsReducer,
    CoLenderFinancierVersionDetailsReducer,
    CoLenderFinancierLatestVersionReducer,
    ApproveCoLenderFinancierReducer,
    RejectCoLenderFinancierReducer,
    BlockCoLenderFinancierReducer,
    FreezeCoLenderFinancierReducer,
    UnfreezeCoLenderFinancierReducer
}